import { render, staticRenderFns } from "./ConfigureOTP.vue?vue&type=template&id=19e39d84&scoped=true&"
import script from "./ConfigureOTP.vue?vue&type=script&lang=js&"
export * from "./ConfigureOTP.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureOTP.vue?vue&type=style&index=0&id=19e39d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e39d84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VApp,VCard,VCardText})
